export class AnalyticsOrder {
  packOmapiId: string;
  subPackOmapiId?: string;
  packOmapiIdPrice = 0;
  subPackOmapiIdPrice = 0;

  constructor(packOmapiId: string, packOmapiIdPrice: number, subPackOmapiId?: string, subPackOmapiIdPrice?: number) {
    this.packOmapiId = packOmapiId;
    this.subPackOmapiId = subPackOmapiId;
    this.packOmapiIdPrice = packOmapiIdPrice;
    this.subPackOmapiIdPrice = subPackOmapiIdPrice;
  }

  public totalPrice(): number {
    if (this.subPackOmapiId) {
      return this.packOmapiIdPrice + this.subPackOmapiIdPrice;
    }
    return this.packOmapiIdPrice;
  }

}
